import { render } from "./App.vue?vue&type=template&id=6156e758"
const script = {}

import "@/assets/styles/base.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/djokic/Projects/mariv/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__